import { AppRouterService } from "core/routes/app-router.service";
import { PathEnum } from "core/routes/path.enum";
import { StepsEnum, SubStepsEnum } from "layout/enums/step.enum";
import { Step } from "layout/models/step.model";

export const InvitationSteps: Step[] = [
	{
		id: StepsEnum.WELCOME,
		title: "",
		hideOnMenu: true,
		route: AppRouterService.get(PathEnum.welcome),
	},
	{
		id: StepsEnum.IDENTIFICAZIONE,
		icon: "fa-user-group",
		title: "Identificazione",
		subtitle: "Raccolta documenti",
		route: AppRouterService.get(PathEnum.identification),
		subSteps: [
			{
				id: SubStepsEnum.ANAGRAFICA,
				title: "Anagrafica",
				route: AppRouterService.get(PathEnum.anagraficaInvitation),
			},
			{
				id: SubStepsEnum.CARICHE_PUBBLICHE,
				title: "Cariche pubbliche",
				route: AppRouterService.get(PathEnum.ulterioriInformazioniInvitation),
			},
			{
				id: SubStepsEnum.VERIFICA_IDENTITA,
				title: "Verifica identità",
				route: AppRouterService.get(PathEnum.verificaIdentitaInvitation),
			},
			{
				id: SubStepsEnum.NEXT_STEP,
				title: "",
				hideOnMenu: true,
				route: AppRouterService.get(PathEnum.identificationComplete),
			},
		],
	},
	{
		id: StepsEnum.FIRMA_CONTRATTO,
		title: "",
		hideOnMenu: true,
		route: AppRouterService.get(PathEnum.invitationComplete),
	},
];
